// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"293288ac","311":"293288ac","834":"53ebb42b","912":"38e3ed17","966":"7e381f37"}[chunkId] + ".chunk.css";
};